import { render, staticRenderFns } from "./OurLandlords.vue?vue&type=template&id=0df5451f&"
import script from "./OurLandlords.vue?vue&type=script&lang=js&"
export * from "./OurLandlords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports